/** Empty default for sites without racetracks. Shape: src/data/racetracks.ts. */
import type { Racetrack } from '@/data/racetracks';

export const racetracks: Racetrack[] = [];
